import { Request } from "@/plugin/axios";
import api from "@/constant/api/dashboard/devops/ram/index.js";
const jsonOptions = {
  headers: {
    "Content-Type": "application/json"
  }
};
// 备份计划查询
export function getRamUserList(params) {
  return Request(api.getRamUserList, api.getRamUserList.url, params, jsonOptions);
}
// 备份记录查询
export function getUserGroupList(params) {
  return Request(api.getUserGroupList, api.getUserGroupList.url, params, jsonOptions);
}
